export default {"src":"https://fishbrain.com/_next/static/media/waning_gibbous.b89dfeee.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};